import React, { useState, useEffect } from 'react';
import { X, Eye, EyeOff } from 'lucide-react';
import './AddAdminModal.css';

export default function AddAdminModal({ isOpen, onClose, onAddSuccess, editingAdmin }) {
  const [formData, setFormData] = useState({
    fullName: '',
    username: '',
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (editingAdmin) {
      setFormData({
        fullName: editingAdmin.name,
        username: editingAdmin.email.split('@')[0],
        email: editingAdmin.email,
        password: '' // Password can be left blank on edit unless changing
      });
    } else {
      setFormData({
        fullName: '',
        username: '',
        email: '',
        password: ''
      });
    }
  }, [editingAdmin, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);

    if (!formData.fullName || !formData.username || !formData.email || (!editingAdmin && !formData.password)) {
      setError('Please fill in all required fields');
      return;
    }

    onAddSuccess(formData);

    setFormData({
      fullName: '',
      username: '',
      email: '',
      password: ''
    });
    onClose();
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content add-admin-modal">
        <div className="modal-header">
          <div className="modal-title-group">
            <h2>{editingAdmin ? 'Edit Admin Account' : 'Create Admin Account'}</h2>
            <p className="modal-subtitle">
              {editingAdmin ? 'Update administrator details' : 'Add a new administrator to the system'}
            </p>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            <X size={20} />
          </button>
        </div>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="fullName">Admin full name</label>
            <input
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              placeholder="e.g. Ali Aliyev"
            />
          </div>
          <div className="form-group">
            <label htmlFor="username">Admin username</label>
            <input
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="e.g. alialiyev"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Admin email</label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="e.g. ali.aliyev@smartcargo.com"
            />
          </div>
          <div className="form-group password-group">
            <label htmlFor="password">{editingAdmin ? 'New password (optional)' : 'Temporary password'}</label>
            <div className="password-input-wrapper">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required={!editingAdmin}
                placeholder={editingAdmin ? "Leave blank to keep current password" : "Enter temporary password"}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn-submit create-admin-btn">
              {editingAdmin ? 'Save Changes' : 'Create Admin'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
